/* eslint-disable no-fallthrough */
import React, { createContext, ReactElement, useState, useMemo } from "react"
import { IPlanInfo } from "../models/IPlanInfo"

type AIPlanPricing = {
    hasFetchedData: boolean
    data: IPlanInfo[]
}
export interface IPlanProps {
    aiPlanPricing: AIPlanPricing
    setAIPlanPricing: React.Dispatch<React.SetStateAction<AIPlanPricing>>
}

export const PlanContext = createContext<IPlanProps>({
    aiPlanPricing: {
        hasFetchedData: false,
        data: [],
    },
    setAIPlanPricing: () => {},
})

PlanContext.displayName = "PlanContext"

export function PlanProvider({ children }: { children: ReactElement }) {
    const [aiPlanPricing, setAIPlanPricing] = useState<AIPlanPricing>({
        hasFetchedData: false,
        data: [],
    })

    const value = useMemo(
        () => ({
            aiPlanPricing,
            setAIPlanPricing,
        }),
        [aiPlanPricing],
    )

    return <PlanContext.Provider value={value}>{children}</PlanContext.Provider>
}
export const PlanConsumer = PlanContext.Consumer
